import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformation';
import { AreaOfDeploymentSubForm, Schema as AreaOfDeploymentSchema } from '../subforms/AreaOfDeployment';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';

export const MoehrleRechtsbereichSchema = (settings) => (
    Yup.object()
        .concat(NameAndContactSchema(settings))
        .concat(OtherInformationSchema)
        .concat(AreaOfDeploymentSchema(settings))
        .concat(DocumentsSchema(settings))
);

export const MoehrleRechtsbereich = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationSubForm} colors={colors} />
            <Field component={AreaOfDeploymentSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
        </>
    );
}